
import { Component, ErrorHandler, OnInit, ViewChild } from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../../../shared/user.service';
import swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';



@Component({
  selector: 'app-vender-grid',
  templateUrl: './vender-grid.component.html',
  styleUrls: ['./vender-grid.component.css']
})
export class VenderGridComponent implements OnInit {
  title = "Vendors";
  dtOptions: any = {};
  empListt: any[] = [];
  mode: any;
  DOC_NOs: any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  isSearch: boolean;
  data: any;
  dtTrigger: Subject<any> = new Subject();                           
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

  ngOnInit(): void {
    debugger
    
    this.GetAllVendorDetails(); 
    this.dtOptions = {
    
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', classname: 'btn btn-primary' }
      ],
    }
  }
 
  //List of Case Proceedings
  GetAllVendorDetails() {
   

    this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.UserService.GetAllVendorDetails();
    this.data.subscribe((Response: any) => {
      this.empListt = Response;   
      this.rerender();  
     
       document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      if (error.status == 401 || error.status == 500) {
        this.errorHandler.handleError(error);
      }
      else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');

        
      }
    });  
  }


            
  delete(DOC_NOs) {
    swal({
      title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.data = this.UserService.DeleteVendor(DOC_NOs);
        this.data.subscribe(
          (response: any) => {
            this.GetAllVendorDetails()
            //alert('Inside');;          
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401 || error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          }
        );
      }
    })
  }


         /*for Datatable*/
         ngAfterViewInit(): void {
          this.dtTrigger.next();
        }
      
      
        ngOnDestroy(): void { 
          this.dtTrigger.unsubscribe();
        }
      
        rerender(): void {
          try {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
            });
           this.dtTrigger.next();
          } catch (err) {
            console.log(err);
          }
        }
}





















// WEBPACK FOOTER //
// ./src/app/Pages/Manage/vender/vender-grid/vender-grid.component.ts